import { Field } from "react-final-form";
import { makeStyles } from "@material-ui/core/styles";
import Autocomplete from "src/features/Components/Autocomplete/index";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import MyTextField from "src/features/Components/TextField";
import ProvinceList from "src/features/Utils/provinceList";
import React from "react";
import SearchIcon from "@material-ui/icons/Search";
import styled from "styled-components";

// import { KeyboardDatePicker } from '@material-ui/pickers'

const SearchWrapper = styled(Grid).attrs({
  container: true,
})`
  margin-top: 8px;
`;

const useStyles = makeStyles((theme) => ({
  button: {
    borderRadius: 50,
  },
}));

function Search() {
  const classes = useStyles();
  return (
    <SearchWrapper spacing={2}>
      <Grid item>
        <Field
          name="name"
          placeholder="Search by Store Name"
          variant="outlined"
          component={MyTextField}
        />
      </Grid>
      <Field
        name="province"
        render={({ input, meta }) => (
          <Box mt={1}>
            <Autocomplete
              options={ProvinceList}
              value={input.value}
              getOptionSelected={(option, value) => option === value}
              getOptionLabel={(option) => option}
              onChange={(value) => input.onChange({ target: { value } })}
              renderInput={(params) => (
                <MyTextField
                  placeholder="Province"
                  variant="outlined"
                  {...params}
                />
              )}
            />
          </Box>
        )}
      />
      <Grid item>
        <Button
          size="small"
          color="primary"
          className={classes.button}
          variant="contained"
          disableElevation
          type="submit"
        >
          <SearchIcon />
        </Button>
      </Grid>
    </SearchWrapper>
  );
}

export default Search;
